import React, { useState, useEffect } from 'react';
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Link,
} from 'react-router-dom';
import { ToastContainer } from 'react-toastify';
import axios from 'axios';
import logo from './assets/images/logo.png';
import 'bootstrap/dist/css/bootstrap.css';
import './App.css';

import Chaplains from './containers/Chaplains';
import Churches from './containers/Churches';
import Countries from './containers/Countries';
import Embassies from './containers/Embassies';
import EmergencyNumbers from './containers/EmergencyNumbers';
import InsuranceProviders from './containers/InsuranceProviders';
import Messages from './containers/Messages';
import Login from './containers/Login';
import NotFound from './containers/NotFound';
import { API_ENDPOINTS } from './config/api';

const url = API_ENDPOINTS.COUNTRIES;
let logged_in = sessionStorage.getItem('session') ? true : false;

const App = () => {
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const [cache, setCache] = useState({});
  const [updated, setUpdated] = useState(false);
  const [refresh, setRefresh] = useState(false);
  const [session, updateSession] = useState(false);
  const dropdownClass = dropdownOpen ? ' show' : '';

  const updateCacheHandler = (key, value) => {
    if ( !logged_in ) {
      return;
    }

    setCache({
      ...cache,
      [key]: value,
    });
  }

  const logoutHandler = (e) => {
    e.preventDefault();

    sessionStorage.removeItem('session');
    setCache({});
    setUpdated(false);

    updateSession(!session);

    window.location.href = '/';
  }

  const updateCountriesHandler = () => {
    if ( !updated ) {
      setUpdated(true);
      makeRequest('GET');
    }
  }

  useEffect(() => {
    logged_in = sessionStorage.getItem('session') ? true : false;

    setRefresh(!refresh);
  }, [session]);

  const makeRequest = (method, id) => {
    if ( !logged_in ) {
      return;
    }

    const requestData = {
      method: 'GET',
      signal: AbortSignal.timeout(20000)
    };

    axios(url, requestData).then((response) => {
      updateCacheHandler('countries', response.data);
    }).catch( (error) => {});
  }

  return (
    <Router>
      <div className="App">
        <header>
          <nav className="navbar navbar-light bg-light">
            <div className="container-fluid">
              <Link className="navbar-brand" to="/">
                <img src={logo} alt="" width="190" />
              </Link>

              { logged_in ? <ul className="nav">
                <li className={`nav-item dropdown${dropdownClass}`}>
                  <a 
                    className="nav-link dropdown-toggle" 
                    data-toggle="dropdown" 
                    href="#" 
                    role="button" 
                    aria-haspopup="true" 
                    aria-expanded={dropdownOpen}
                    onClick={(e) => { e.preventDefault(); setDropdownOpen(!dropdownOpen)}}
                  >Sections</a>

                  <div className={`dropdown-menu${dropdownClass}`}>
                    <Link onClick={() => setDropdownOpen(false)} className="dropdown-item" to="/">Churches</Link>
                    <Link onClick={() => setDropdownOpen(false)} className="dropdown-item" to="/countries">Countries</Link>
                    <Link onClick={() => setDropdownOpen(false)} className="dropdown-item" to="/embassies">Embassies</Link>
                    <Link onClick={() => setDropdownOpen(false)} className="dropdown-item" to="/chaplains">Chaplains</Link>
                    <Link onClick={() => setDropdownOpen(false)} className="dropdown-item" to="/emergency-numbers">Emergency Numbers</Link>
                    <Link onClick={() => setDropdownOpen(false)} className="dropdown-item" to="/insurance-providers">Insurance Providers</Link>
                    <Link onClick={() => setDropdownOpen(false)} className="dropdown-item" to="/messages">Messages</Link>
                  </div>
                </li>

                <li className="nav-item">
                  <a className="nav-link" href="#" onClick={(e) => logoutHandler(e)}>Logout</a>
                </li>
              </ul> : null }
            </div>
          </nav>
        </header>

        <Routes>
          { logged_in ? <Route exact path="/" element={<Churches
              updateSession={() => updateSession(!session)}
              cached={cache}
              updateCache={(data) => updateCacheHandler('churches', data)} 
              updateCountriesHandler={() => updateCountriesHandler()}
            />} /> : null }

          { logged_in ? <Route path="/countries" element={<Countries
              updateSession={() => updateSession(!session)} 
              cached={cache} 
              updateCache={(data) => updateCacheHandler('countries', data)} 
              updateCountriesHandler={() => updateCountriesHandler()}
            />} /> : null }

          { logged_in ? <Route path="/embassies" element={<Embassies 
              updateSession={() => updateSession(!session)} 
              cached={cache} 
              updateCache={(data) => updateCacheHandler('embassies', data)} 
              updateCountriesHandler={() => updateCountriesHandler()}
            />} /> : null }

          { logged_in ? <Route path="/chaplains" element={<Chaplains 
              updateSession={() => updateSession(!session)} 
              cached={cache} 
              updateCache={(data) => updateCacheHandler('chaplains', data)} 
              updateCountriesHandler={() => updateCountriesHandler()}
            />} /> : null }

          { logged_in ? <Route path="/emergency-numbers" element={<EmergencyNumbers 
              updateSession={() => updateSession(!session)} 
              cached={cache} 
              updateCache={(data) => updateCacheHandler('emergencyNumbers', data)} 
              updateCountriesHandler={() => updateCountriesHandler()}
            />} /> : null }

          { logged_in ? <Route path="/insurance-providers" element={<InsuranceProviders 
              updateSession={() => updateSession(!session)} 
              cached={cache} 
              updateCache={(data) => updateCacheHandler('insuranceProviders', data)} 
              updateCountriesHandler={() => updateCountriesHandler()}
            />} /> : null }

          { logged_in ? <Route path="/messages" element={<Messages 
              updateSession={() => updateSession(!session)} 
              cached={cache} 
              updateCache={(data) => updateCacheHandler('messages', data)} 
              updateCountriesHandler={() => updateCountriesHandler()}
            />} /> : null }

          { !logged_in ? <Route exact path="/" element={<Login updateSession={() => updateSession(!session)} />} /> : null }
          
          <Route path="*" element={<NotFound />} />
        </Routes>
        
        <footer style={{
          textAlign: 'center', 
          padding: 16,
          borderWidth: 1,
          borderStyle: 'solid',
          borderColor: '#ebebeb',
          color: '#222'
        }}>Sjømannskirken - Norsk kirke i utlandet</footer>
      </div>

      <ToastContainer />
    </Router>
  );
}

export default App;